
import * as React from "react"
import { FluentCustomizations } from '@uifabric/fluent-theme';
import { initializeIcons } from '@uifabric/icons';
import * as Immutable from 'immutable';
import { Customizer, Fabric, loadTheme } from 'office-ui-fabric-react';
import { any, Action, async, AsyncState, mk_widget, IOWidget, mkWidget } from "widgets-for-react";
import {
  // School, PublicRelation, 
  Label
} from "../../generated_models";
import { AsyncMonitor } from "./async_monitor";
import { FormAppState, form_renderer } from "./renderers";
import { Loader, loader } from "../public_site/templates/loader.mod";
import { DependenciesState, DependencyId, DependencyResult, FieldData, FieldId, FormData, FormState, IsMet } from "./types";
// import { form_renderer } from "./renderers";
import { get_all_fields, get_dependency_result } from "./utils";

initializeIcons();

loadTheme({
  defaultFontStyle: {
    fontFamily: '"Open Sans", sans-serif',
    fontSize: 16,
    lineHeight: 24
  },
});

export let Form = (outerSetState:(output: Action<FormAppState>) => void, 
  formAppState:FormAppState, 
  state_outer: any,
  set_state_outer: (_:any) => any, should_disable_last_check:boolean,
  tabId?:number,sectionId?:number) : IOWidget<FormState, Action<FormState>> => s0 => {
      
  // let checkboxRadioLabelFilter = (title:string, label:Label) => {
  //   if (title.startsWith('Vraag 5') || title.startsWith('Vraag 32') || title.startsWith('Vraag 33')) {
  //     let filtered = appState.educationLevels.kind == 'loaded' && appState.educationLevels.value.filter(el => el.Name == label.label)
  //     if (filtered && filtered.length > 0)
  //       return true
  //     return false
  //   }
  //   else if (title.startsWith('Vraag 29')) {
  //     if (label.label == 'Screenen op dyslexie' || label.label == 'Screenen op dyscalculie') {
  //       let filtered = appState.educationLevels.kind == 'loaded' && appState.educationLevels.value.filter(el => el.Name == 'ZML-onderwijs')
  //       if (filtered && filtered.length > 0)
  //         return false
  //       return true
  //     }
  //     else if (label.label == 'Screenen op (hoog)begaafdheid') {
  //       let filtered = appState.educationLevels.kind == 'loaded' && appState.educationLevels.value.filter(el => el.Name == 'ZML-onderwijs' || el.Name == 'Praktijkonderwijs')
  //       if (filtered && filtered.length > 0)
  //         return false
  //       return true
  //     }
  //     return true
  //   }
  //   return true
  // }
  
      let dependencies_async_list = Immutable.List<{ dep_res: { kind: "async", value: AsyncMonitor<IsMet> }, dep_id: DependencyId, field_id: FieldId }>()
      s0.dependencies_state.forEach((field_id__dep_res, dep_id) => {
        field_id__dep_res.forEach((dep_res, field_id) => {
          if (dep_res.kind == "async")
            dependencies_async_list = dependencies_async_list.push({ dep_id, field_id, dep_res })
        })
      })
      return (
        any<Action<FormState>>({key: `${s0.form_data.kind}-${s0.form_submission_logic.kind}`})(
          //we load the async dependencies
          dependencies_async_list.map((dep_elem, index) => {
            return dep_elem.dep_res.value.Widget.map<Action<FormState>>(a => s => {
              let s1 = s
              let a1 = a
              let field_id__dep_res = s.dependencies_state.get(dep_elem.dep_id).set(dep_elem.field_id, { kind: "async", value: a1 })
              return { ...s1, dependencies_state: s1.dependencies_state.set(dep_elem.dep_id, field_id__dep_res) }
            })
          }).toArray().concat([               
              //we load the form
              async<string>(null, {
                key : "submission form async",
                // connectionError:string({readonly:true, readonly_element:"p", className:"message message--error"})("Probleem met verbinden").never(),                
                // loading:(state => string({readonly:true, readonly_element:"p", className:"message"})("Formulier wordt verzonden").never()),
                // unauthorizedError:string({readonly:true, readonly_element:"p", className:"message message--error"})("Geen toegang").never(),
                // otherError:string({readonly:true, readonly_element:"p", className:"message message--error"})("Er is iets fout gegaan").never(),
                unloaded:null,
                connectionError:mkWidget({run: _ => <div className="connection-error">Connection error.</div>}),
                otherError:mkWidget({run: _ => <div className="error">Error.</div>}),
                loading:_ => loader
              })(s0.form_submission_logic)
                .map<Action<FormState>>(a => s => {
                  let a1 = a(s.form_submission_logic)
                  return {...s, form_submission_logic:a1}
                }),
                // async<FormData>()(s0.form_data)
                // .map<Action<FormState>>(a => state => {
                  
                //   if(appState.educationLevels.kind == "loaded"){
                //     let past_extra_input_for_dependency_check = state.extra_input_for_dependency_check()
                //     let education_levels1 = appState.educationLevels.value.map(el => el.Name)
                //     let lst = past_extra_input_for_dependency_check.concat(education_levels1).toList()
                //     state.extra_input_for_dependency_check = () => lst
                //   }

                //   if(appState.schoolFormData.kind == "loaded"){
                //     let past_extra_input_for_dependency_check = state.extra_input_for_dependency_check()
                //     if(appState.schoolFormData.value.School.VSO){
                //       let lst = past_extra_input_for_dependency_check.concat(["VSO"]).toList()
                //       state.extra_input_for_dependency_check = () => lst
                //     }
                //   }

                //   return LoadFormData(a, state, checkboxRadioLabelFilter)
                // }),
              mk_widget({
                run: set_state => {
                  if (s0.form_data.kind != "loaded") return <p className="text-1 message">{s0.form_data.kind}</p>
                  if (s0.form_submission_logic.kind == "loading") return <></>
                  return form_renderer(s0.form_data.value, formAppState, 
                              (new_form_submission_logic) => set_state(s => ({...s, form_submission_logic:new_form_submission_logic})),
                              (new_form, new_dependencies) => set_state(s => {
                                if (s.form_data.kind != "loaded") return s
                                return { ...s, form_data: { ...s.form_data, value: new_form }, dependencies_state: new_dependencies, dirty: true }
                              }),
                              state_outer,
                              set_state_outer,
                              should_disable_last_check,
                              tabId,
                              sectionId,
                              // checkboxRadioLabelFilter
                              ).run(outerSetState)
                }
              })

            ]))
            ).wrapHTML(jsx => (
              <Fabric className="block__form">
                <Customizer {...FluentCustomizations}>
                    {jsx}
                </Customizer>
              </Fabric>
            ))
            
        }

// export let FormNew : IOWidget<FormState, Action<FormState>> = (s0) => mk_widget({
//   run: set_state => {
//     return form_renderer(undefined,undefined,undefined,undefined,undefined,undefined).run(null)
//   }
// })


export let LoadFormData = (a: Action<AsyncState<FormData>>, state: FormState, checkboxRadioLabelFilter?: (title: string, label: Label) => boolean):FormState => {
  let a1 = a(state.form_data)
  let new_state = { ...state, form_data: a1 }
  if (new_state.form_data.kind == "loaded") {
    let all_fields_list: Array<[FieldId,FieldData]> = new Array()
    new_state.form_data.value.tabs.forEach(tab => tab.sections.forEach(section => section.steps.forEach(s => s.fields.forEach(f => {
        all_fields_list.push([f.field.Id,f])
        let add_nested_fields = (f: FieldData) => {
          f.maybe_answers?.forEach(answer => answer.nested_fields?.forEach(nested_field => {
            all_fields_list.push([nested_field.field.Id,nested_field])
            add_nested_fields(nested_field)
          }))
        }
        add_nested_fields(f)
      })
    )))
    let all_fields: Immutable.Map<FieldId, FieldData> = Immutable.Map<FieldId, FieldData>(all_fields_list) 

    let extra_input_for_dependency_check = new_state.form_data.value.tags
    new_state.extra_input_for_dependency_check = () => Immutable.List(extra_input_for_dependency_check).concat(state.extra_input_for_dependency_check()).toList()

    let dependenciesState: DependenciesState = Immutable.Map()
    
    
    let _all_fields = get_all_fields(new_state)
    new_state.form_data.value.tabs.forEach(tab => tab.sections.forEach(section => section.steps.forEach(s => {
      s.fields.forEach(field => field.maybe_labels = field.maybe_labels.filter(label => checkboxRadioLabelFilter(field.field.title, label)))

      s.dependencies.forEach(d => {
        let dependent_fields = Immutable.Map<FieldId, DependencyResult>()
        d.dependent_fields.forEach(f => {
          if (all_fields.has(f.FieldId)) {
            let field_dep_state = dependent_fields.get(f.FieldId)
            let dependency_result = get_dependency_result(all_fields.get(f.FieldId), all_fields.get(f.FieldId).user_input, new_state.extra_input_for_dependency_check, d.dependency, _all_fields, field_dep_state && field_dep_state.kind == "async" ? field_dep_state.value : undefined)
            if (dependency_result.kind == "simple" && dependency_result.value == false) {
              dependent_fields = dependent_fields.set(f.FieldId, dependency_result)
            }
            else {
              if (dependency_result.kind == "async") {
                if (dependency_result.value.Result.kind == "loaded" && dependency_result.value.Result.value == false)
                  dependent_fields = dependent_fields.set(f.FieldId, dependency_result)
                else {
                  if (dependency_result.value.Result.kind != "unloaded") {
                    dependent_fields = dependent_fields.set(f.FieldId, dependency_result)
                  }
                }
              }
            }
          }
        else {

        }
        })
        dependenciesState = dependenciesState.set(d.dependency.Id, dependent_fields)
      })

    })))
    new_state.dependencies_state = dependenciesState
  }
  return new_state
}


// export let LoadSchoolFormData = (a: Action<AsyncState<FormData>>, state: FormState, schoolFormData?:SchoolFormData):FormState => {
//   let a1 = a(state.form_data)
//   if(a1.kind == 'loaded' && schoolFormData)
//     a1.value = addSchoolToUserInput(a1.value,schoolFormData)
//   let new_state = { ...state, form_data: a1 }
//   if (new_state.form_data.kind == "loaded") {
//     let all_fields_list: Array<[FieldId,FieldData]> = new Array()
//     new_state.form_data.value.tabs.forEach(tab => tab.sections.forEach(section => section.steps.forEach(s => s.fields.forEach(f => {
//           all_fields_list.push([f.field.Id,f])
//     })
//     )))
//     let all_fields: Immutable.Map<FieldId, FieldData> = Immutable.Map<FieldId, FieldData>(all_fields_list) 

//     let dependenciesState: DependenciesState = Immutable.Map()
//     new_state.form_data.value.tabs.forEach(tab => tab.sections.forEach(section => section.steps.forEach(s => {
//       s.dependencies.forEach(d => {
//         let dependent_fields = Immutable.Map<FieldId, DependencyResult>()
//         d.dependent_fields.forEach(f => {
//           if (all_fields.has(f.FieldId)) {
//             let field_dep_state = dependent_fields.get(f.FieldId)
//             let dependency_result = get_dependency_result(all_fields.get(f.FieldId), all_fields.get(f.FieldId).user_input, state.extra_input_for_dependency_check, d.dependency,  field_dep_state && field_dep_state.kind == "async" ? field_dep_state.value : undefined)
//             if (dependency_result.kind == "simple" && dependency_result.value == false) {
//               dependent_fields = dependent_fields.set(f.FieldId, dependency_result)
//             }
//             else {
//               if (dependency_result.kind == "async") {
//                 if (dependency_result.value.Result.kind == "loaded" && dependency_result.value.Result.value == false)
//                   dependent_fields = dependent_fields.set(f.FieldId, dependency_result)
//                 else {
//                   if (dependency_result.value.Result.kind != "unloaded") {
//                     dependent_fields = dependent_fields.set(f.FieldId, dependency_result)
//                   }
//                 }
//               }
//             }
//           }
//         })
//         dependenciesState = dependenciesState.set(d.dependency.Id, dependent_fields)
//       })
//     })))
//     new_state.dependencies_state = dependenciesState
//   }
//   return new_state
// }

// export let LoadPRFormData = (a: Action<AsyncState<FormData>>, state: FormState, pr:PublicRelation | undefined):FormState => {
//   let a1 = a(state.form_data)
//   if(a1.kind == 'loaded' && pr)
//     a1.value = addPRToUserInput(a1.value,pr)
//   let new_state = { ...state, form_data: a1 }
//   if (new_state.form_data.kind == "loaded") {
//     let all_fields_list: Array<[FieldId,FieldData]> = new Array()
//     new_state.form_data.value.tabs.forEach(tab => tab.sections.forEach(section => section.steps.forEach(s => s.fields.forEach(f => {
//           all_fields_list.push([f.field.Id,f])
//     })
//     )))
//     let all_fields: Immutable.Map<FieldId, FieldData> = Immutable.Map<FieldId, FieldData>(all_fields_list) 

//     let dependenciesState: DependenciesState = Immutable.Map()
//     new_state.form_data.value.tabs.forEach(tab => tab.sections.forEach(section => section.steps.forEach(s => {
//       s.dependencies.forEach(d => {
//         let dependent_fields = Immutable.Map<FieldId, DependencyResult>()
//         d.dependent_fields.forEach(f => {
//           if (all_fields.has(f.FieldId)) {
//             let field_dep_state = dependent_fields.get(f.FieldId)
//             let dependency_result = get_dependency_result(all_fields.get(f.FieldId), all_fields.get(f.FieldId).user_input, state.extra_input_for_dependency_check, d.dependency,  field_dep_state && field_dep_state.kind == "async" ? field_dep_state.value : undefined)
//             if (dependency_result.kind == "simple" && dependency_result.value == false) {
//               dependent_fields = dependent_fields.set(f.FieldId, dependency_result)
//             }
//             else {
//               if (dependency_result.kind == "async") {
//                 if (dependency_result.value.Result.kind == "loaded" && dependency_result.value.Result.value == false)
//                   dependent_fields = dependent_fields.set(f.FieldId, dependency_result)
//                 else {
//                   if (dependency_result.value.Result.kind != "unloaded") {
//                     dependent_fields = dependent_fields.set(f.FieldId, dependency_result)
//                   }
//                 }
//               }
//             }
//           }
//         })
//         dependenciesState = dependenciesState.set(d.dependency.Id, dependent_fields)
//       })
//     })))
//     new_state.dependencies_state = dependenciesState
//   }
//   return new_state
// }